import { Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import questionMarkBlack from "../../assets/icons/questionMarkBlack.svg";
import "./styles.less";
import { translationWrapper } from "utils/common-methods";

export const AccountModal = ({ Image, ...props }: any) => {
    const {t} = translationWrapper(useTranslation());
    const { title, content } = props.accountModalData;
    const { disableFooter = false, titleLeftIcon = questionMarkBlack} = props;
    return (
        <div className="account-modal">
            <Modal
                title={
                    <>
                        <img src={titleLeftIcon} alt="questionMarkBlack" />
                        <span className="account-modal-title">{title}</span>
                    </>
                }
                visible={props.isModalVisible}
                onOk={() => props.setIsModalVisible(false)}
                onCancel={() => props.setIsModalVisible(false)}
                width={430}
                wrapClassName={`account-modal-container ${disableFooter ? 'disable-footer-account-modal-container':''}`}
                okText={t("global.button.got_it")}
                cancelButtonProps={{ style: { display: "none" } }}
            >
                <div className="account-modal-content-container">
                    <div className="account-modal-image">
                        <Image farmText={t("farms")} workspaceText={t("workspaces")} orgText={t("organizations")} />
                    </div>
                    <div className="account-modal-content-box">{content}</div>
                    {props.children}
                </div>
            </Modal>
        </div>
    );
};
export const InfoModal = AccountModal;
